const initialState = {
  breadcrumb: {},
  progress: 0,
  page: 1,
  paramId: '',
  loading: false,
  isCanvaRender: true,
  isArchive:false
}

export const general = (state = initialState, action) => {
  switch (action.type) {
    case "BREADCRUMB": return { ...state, breadcrumb: action.data };
    case "SET_PAGE": {
      return { ...state, page: action.data }
    }
    case "SET_PARAM_FIRST": {
      return { ...state, paramId: action.data }
    }
    case "ISLOADING":
      return { ...state, loading: action.data }
    case "PROGRESS":
      return { ...state, progress: action.data }
    case "CANVARENDER":
      return { ...state, isCanvaRender: action.data }
    case "SET_ARCHIVE_FILTER":
      return { ...state, isArchive: action.data }  
    default:
      return state;
  }
};